import styled from 'styled-components'

export const SingalProfile = styled.div`
padding: 20px;
background-color: white;
box-shadow: 0 0 10px rgb(136 136 136 / 20%);
border-radius: 5px;
img{
    width: 100%;
    box-shadow: 0px 2px 4px 3px rgb(83 61 82 / 6%);
    padding: 8px;
    max-height: 575px;
    border-radius: 5px;
}
`;

export const TeacherDescription = styled.div`
padding: 20px;
h6{
    font-size: 15px;
    font-weight: 600;
    text-transform: capitalize;
    margin-bottom: 13px;
}
h6:nth-child(1){
    font-size: 1.5rem;
    margin-bottom: 3px;
}
p:nth-child(2){
    margin-bottom: 3px;
}
p{
    font-size: 13px;
    color: #4c4c4c;
    margin-bottom: 13px;
}
>span{
    margin-bottom: 13px;
    display: block;
}
`;

export const PersonalInfo = styled.div`
div{
    margin-bottom: 11px;
}
div i{
    color: var(--primaryColor);
    font-size: 14px;
    margin-right: 11px;
}
div span:nth-child(2){
    color: #3c3c3c;
    font-size: 14px;
    margin-right: 60px;
    font-weight: 500;
}
div span:nth-child(3){
    color: #848484;
    font-size: 14px;
}
`;